import { MRT_ColumnDef } from "material-react-table";
import { Box, Button, Chip, Divider, IconButton, Tooltip, Typography } from "@mui/material";
import CustomPopup from "../../../../shared/components/modals/custom-popup";
import CBReasonDetails from "./cb-reason-deatils";
import { MouseEvent, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CustomButton } from "../../../../shared/components/buttons/buttons";
import ModalPopup from "../../../../shared/components/modals/custom-popup";
import DataDisplay from "../tc-components/tc-error-detail-panel";
import moment from "moment";
import { StyledButton } from "../../../../shared/components/buttons/custom-button";
import { ActionsMenu } from "../../../../shared/components/table/custom-actions";
import { useApi } from "../../../../shared/hooks/useApi";
import { TCAppConfig } from "../../../../shared/app-configs/tc-app-configs";
import { useTransactionCertificateStore } from "../../../../store/transaction-certificates.store";
import { ICbLandingPageDTrackitTableDataV4 } from "../../../../screens/v4/transaction-certificates/tc-models/tc-resp-dto/cb-landingpage.res_dto";
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import RateReviewIcon from '@mui/icons-material/RateReview';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import useRecordsStore from "../../../../shared/hooks/useRecordStore";
import { TcPdfUploaderModal } from "./TcPdfUploaderModal";
import FileView from "../tc-components/ml-files-detail-panel";
import { MLAppConfig } from "../../../../shared/app-configs/ml-app-configs";
import ViewerModalPopup from "../../../../shared/components/modals/viewerModal";
import PdfViewer from "../../../../shared/components/preview/pdf-viewer";
// Common status cell renderer
export const StatusCell = ({ cell }: { cell: any }) => {
    const status = cell.getValue() as string;
    let color: "default" | "primary" | "secondary" | "error" | "info" | "success" | "warning" = "default";
    switch (status) {
        case "Submitted": color = "success"; break;
        case "Success": color = "success"; break;
        case "Amending": color = "info"; break;
        case "Rejected": color = "error"; break;
        case "Created": color = "warning"; break;
        case "Draft": color = "warning"; break;
        default: color = "default";
    }
    return <Chip label={status} color={color} size="small" variant="outlined" />;
};

export const certifiedWeightCell = ({ cell }: { cell: any }) => {
    const weightUsed = cell.getValue() as string;
    if (parseInt(weightUsed) > 0) {
        return new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(parseInt(weightUsed));
    }
    return weightUsed
};


interface NavTCNoProps {
    cell: {
        getValue: () => string;
        row: {
            original: {
                tcMetadataStatus: string;
                tcId: string;
                tcParentMetadataStatus: string;
                tcNo?: string;
                tcVersionNo?: string;
                tcPdfUploadStatus?: string;
                tcUploadedFileName?: string;
                tcNoPdfUrl?: string;
                tcVersionNoPdfUrl?: string;
                tcUploadedFiles?: Array<{ fileName: string; blobUrl: string; uploadedDate: string }>;
                tcDateOfIssue?: string;
            };
        };
    },
    type: string;
}
const NavTCNo: React.FC<NavTCNoProps> = ({ cell, type }) => {
    const navigate = useNavigate();
    const { setEditTCInfo,cbLicensingCode } = useTransactionCertificateStore();
    // Extracting necessary values
    const tcNo = cell.getValue(); // Transaction Certificate Number
    const { tcMetadataStatus, tcId, tcParentMetadataStatus } = cell.row.original;
    // Click handler to navigate based on tcMetadataStatus
    const handleNavigation = () => {
        if (type === 'suppliers') {
            navigate(`/v4/tc/submited-tc/transaction-certificate/${tcId}`);
            return;
        }
        else {
            if (
              tcParentMetadataStatus === "Submitted" || 
              tcParentMetadataStatus === "Success" || 
              tcParentMetadataStatus === "Rejected" ||
              tcMetadataStatus === "Amending"
            ) {
                setEditTCInfo({ tcId: tcId, isParentStatus: true });
            }
            else {
                setEditTCInfo({ tcId: tcId, isParentStatus: false });
            }
            navigate(`/v4/tc/base-details/transaction-certificate/${tcId}`);
        }
    };

    return (
        <Typography
            onClick={handleNavigation}
            variant="body2"
            sx={{
                cursor: "pointer",
                color: "primary.main",
                textDecoration: "underline",
                "&:hover": {
                    color: "primary.dark", // Slightly darker color on hover
                },
                "&:active": {
                    textDecoration: "none", // Remove underline when clicked
                },
            }}
        >
            {tcNo}
        </Typography>
    );
};


// const EditNavTCNo: React.FC<NavTCNoProps> = ({ cell, type }) => {
//     const navigate = useNavigate();
//     const row = cell.row.original;
//     // Extracting necessary values
//     const tcNo = cell.getValue(); // Transaction Certificate Number
//     const { tcId, tcMetadataStatus } = cell.row.original;

//     // Click handler to navigate based on tcMetadataStatus
//     const handleNavigation = () => {
//         console.log(`row value edit ${JSON.stringify(row)}`);

//         // if (type === 'suppliers') {
//         //     navigate(`/tc/submited-tc/transaction-certificate/${tcId}`);
//         // }
//         // else
//         //     navigate(`/tc/tc-details/transaction-certificate/${tcId}`);
//     };

//     return (
//         <>
//             {
//                 row.tcMetadataStatus === 'Submitted' || row.tcMetadataStatus === 'Success' || row.tcMetadataStatus === 'Rejected' ?
//                     <CustomButton variant="text" sx={{ textTransform: "none" }} size="small" label="Edit" onClick={handleNavigation}>
//                     </CustomButton> : null
//             }
//         </>
//     );
// };
interface NavETCNoProps {
    cell: {
        getValue: () => string;
        row: {
            original: {
                tcMetadataStatus: string;
                etcId: string;
            };
        };
    };
}

export const NavETCNo: React.FC<NavETCNoProps> = ({ cell }) => {
    const navigate = useNavigate();

    // Extracting necessary values
    const etcNo = cell.getValue(); // Transaction Certificate Number
    const { tcMetadataStatus, etcId } = cell.row.original;

    // Click handler to navigate based on tcMetadataStatus
    const handleNavigation = () => {
        navigate(`/etc/view-etc/transaction-details/${etcId}`);
    };

    return (
        <Typography
            onClick={handleNavigation}
            variant="body2"
            sx={{
                cursor: "pointer",
                color: "primary.main",
                textDecoration: "underline",
                "&:hover": {
                    color: "primary.dark", // Slightly darker color on hover
                },
                "&:active": {
                    textDecoration: "none", // Remove underline when clicked
                },
            }}
        >
            {etcNo}
        </Typography>
    );
};
export const NavSupNo: React.FC<any> = ({ cell }) => {
    const navigate = useNavigate();

    // Extracting necessary values
    const tcNo = cell.getValue(); // Transaction Certificate Number
    const { tcMetadataStatus, tcId } = cell.row.original;

    // Click handler to navigate based on tcMetadataStatus
    const handleNavigation = () => {
        navigate(`/v4/tc/submited-tc/transaction-certificate/${tcId}`);
    };

    return (
        <Typography
            onClick={handleNavigation}
            variant="body2"
            sx={{
                cursor: "pointer",
                color: "primary.main",
                textDecoration: "underline",
                "&:hover": {
                    color: "primary.dark", // Slightly darker color on hover
                },
                "&:active": {
                    textDecoration: "none", // Remove underline when clicked
                },
            }}
        >
            {tcNo}
        </Typography>
    );
};
const RejectReasonCell = ({ row }: { row: any }) => {
    const [open, setOpen] = useState(false);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const rejectionReasons = Array.isArray(row.original.tcMetadataRejectionReason)
        ? row.original.tcMetadataRejectionReason
        : [row.original.tcMetadataRejectionReason];

    return (
        <>
            {Array.isArray(row.original.tcMetadataRejectionReason) ? (
                <>
                    <CustomButton variant="text" sx={{ textTransform: "none" }} size="small" label="Show Reason" onClick={handleOpen}>
                    </CustomButton>
                    <ModalPopup open={open} onClose={handleClose} title="Rejection Reason">
                        <DataDisplay data={rejectionReasons} />
                    </ModalPopup>
                </>
            ) : (
                <span>{row.original.tcMetadataRejectionReason}</span>
            )}
        </>
    );
};

export const InventoryFIlesView = ({ row }: { row: any }) => {
    const [open, setOpen] = useState(false);
    const [sasUrls, setSasUrls] = useState<{[key: string]: string}>({});
    const [isLoading, setIsLoading] = useState(false);

    const handleOpen = () => {
        setOpen(true);
        fetchSasUrls();
    };
    
    const handleClose = () => setOpen(false);
    
    const { executeGet } = useApi();
    const files = Array.isArray(row.original.files)
        ? row.original.files
        : [row.original.files];

    const hasFiles = row.original.files && 
                    (Array.isArray(row.original.files) 
                      ? row.original.files.length > 0
                      : (row.original.files.fileName && row.original.files.fileName.length > 0));

    const getSasUrl = async (filePath: string) => {
        try {
            const formattedPath = `['${filePath}']`;
            console.log("formattedPath", formattedPath);
            const result: any = await executeGet(MLAppConfig.GET_SAS_URL, {
                files: formattedPath
            });
            console.log("sasURL------->", JSON.stringify(result.data));
            return result.data[0];
        } catch (error: any) {
            throw new Error(`Failed to get SAS URL: ${error.message}`);
        }
    };
    
    const fetchSasUrls = async () => {
        if (!row.original.files || !row.original.files.filePath) return;
        
        setIsLoading(true);
        try {
            const urls: {[key: string]: string} = {};
            const filePaths = row.original.files.filePath;
            const fileNames = row.original.files.fileName;
            
            if (Array.isArray(filePaths)) {
                for (let i = 0; i < filePaths.length; i++) {
                    const url = await getSasUrl(filePaths[i]);
                    urls[fileNames[i]] = url;
                }
            }
            // console.log("urls-------->", urls);
            setSasUrls(urls);
        } catch (error) {
            console.error("Error fetching SAS URLs:", error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            {hasFiles ? (
                <>
                    <CustomButton 
                        variant="text" 
                        sx={{ textTransform: "none" }} 
                        size="small" 
                        label="Show Files" 
                        onClick={handleOpen}
                    >
                    </CustomButton>
                    <ModalPopup open={open} onClose={handleClose} title="Inventory Files">
                        <FileView files={files} sasUrls={sasUrls} isLoading={isLoading} />
                    </ModalPopup>
                </>
            ) : (
               <span> </span>
            )}
        </>
    );
};
const TcPdfMultiViewer = ({
    tcNoPdfUrl, tcVersionNoPdfUrl, tcNo, tcVersionNo, fallbackApiUrl, tcId,
}: {
    tcNoPdfUrl?: string;
    tcVersionNoPdfUrl?: string;
    tcNo?: string;
    tcVersionNo?: string;
    fallbackApiUrl: string;
    tcId: string;
}) => {
    // Build file list — versioned (most recent) first. Use static labels because
    // tcVersionNo may equal tcNo when the TC metadata hasn't been updated yet.
    const files = [
        tcVersionNoPdfUrl && tcVersionNoPdfUrl !== tcNoPdfUrl
            ? { label: 'Amended Certificate', url: tcVersionNoPdfUrl, isBase: false }
            : null,
        tcNoPdfUrl
            ? { label: 'Original Certificate', url: tcNoPdfUrl, isBase: true }
            : null,
    ].filter(Boolean) as Array<{ label: string; url: string; isBase: boolean }>;

    const [activeIdx, setActiveIdx] = useState(0);

    if (files.length === 0) {
        return (
            <div style={{ width: '100%', height: '100vh' }}>
                <PdfViewer apiUrl={fallbackApiUrl} params={{ tcId }} />
            </div>
        );
    }

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            {files.length > 1 && (
                <Box sx={{ display: 'flex', gap: 1, p: 1.5, borderBottom: '1px solid rgba(44,71,72,0.1)', backgroundColor: '#FAFCFC', flexShrink: 0 }}>
                    {files.map((f, i) => {
                        const isActive = activeIdx === i;
                        const activeColor = f.isBase ? '#2d6a4f' : '#d97706';
                        const borderColor = f.isBase ? 'rgba(45, 106, 79, 0.35)' : 'rgba(249, 115, 22, 0.35)';
                        return (
                        <Chip
                            key={i}
                            label={f.label}
                            onClick={() => setActiveIdx(i)}
                            variant={isActive ? 'filled' : 'outlined'}
                            size="small"
                            sx={{
                                cursor: 'pointer',
                                fontWeight: 600,
                                fontSize: '11px',
                                backgroundColor: isActive ? activeColor : 'transparent',
                                color: isActive ? '#FFFFFF' : activeColor,
                                borderColor: isActive ? activeColor : borderColor,
                            }}
                        />
                        );
                    })}
                </Box>
            )}
            <iframe
                key={files[activeIdx].url}
                src={files[activeIdx].url}
                title={files[activeIdx].label}
                width="100%"
                style={{ flex: 1, border: 'none', minHeight: '80vh' }}
            />
        </Box>
    );
};

const UploadedFilesChip = ({
    files,
}: {
    files: Array<{ fileName: string; pdfUrl: string; isBase: boolean; label: string }>;
}) => {
    const [open, setOpen] = useState(false);
    const [activeIdx, setActiveIdx] = useState(0);

    if (files.length === 0) return null;

    const hasMultiple = files.length > 1;
    const activeFile = files[activeIdx];

    const chipSx = hasMultiple
        ? { borderColor: 'rgba(44, 71, 72, 0.35)', backgroundColor: 'rgba(44, 71, 72, 0.04)', color: '#2C4748', '&:hover': { backgroundColor: 'rgba(44, 71, 72, 0.12)' } }
        : files[0].isBase
        ? { borderColor: 'rgba(45, 106, 79, 0.35)', backgroundColor: 'rgba(45, 106, 79, 0.04)', color: '#2d6a4f', '&:hover': { backgroundColor: 'rgba(45, 106, 79, 0.12)' } }
        : { borderColor: 'rgba(249, 115, 22, 0.35)', backgroundColor: 'rgba(249, 115, 22, 0.04)', color: '#d97706', '&:hover': { backgroundColor: 'rgba(249, 115, 22, 0.12)' } };

    const chipLabel = hasMultiple ? `View PDFs (${files.length})` : files[0].label;
    const tooltipTitle = hasMultiple
        ? `Click to view ${files.length} uploaded PDFs — toggle between versions`
        : `Click to view: ${files[0].fileName}`;

    return (
        <>
            <Tooltip title={tooltipTitle} arrow placement="top">
                <Chip
                    label={chipLabel}
                    variant="outlined"
                    size="small"
                    onClick={(e) => { e.stopPropagation(); setActiveIdx(0); setOpen(true); }}
                    sx={{ cursor: 'pointer', fontWeight: 600, fontSize: '11px', borderRadius: '6px', ...chipSx }}
                />
            </Tooltip>
            {open && (
                <ViewerModalPopup
                    open={open}
                    onClose={() => setOpen(false)}
                    title={hasMultiple ? `Uploaded PDFs (${files.length})` : files[0].label}
                >
                    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                        {hasMultiple && (
                            <Box sx={{ display: 'flex', gap: 1, p: 1.5, borderBottom: '1px solid rgba(44,71,72,0.1)', backgroundColor: '#FAFCFC', flexShrink: 0 }}>
                                {files.map((f, i) => {
                                    const isActive = activeIdx === i;
                                    const activeColor  = f.isBase ? '#2d6a4f' : '#d97706';
                                    const borderColor  = f.isBase ? 'rgba(45, 106, 79, 0.35)' : 'rgba(249, 115, 22, 0.35)';
                                    return (
                                    <Chip
                                        key={i}
                                        label={f.label}
                                        onClick={() => setActiveIdx(i)}
                                        variant={isActive ? 'filled' : 'outlined'}
                                        size="small"
                                        sx={{
                                            cursor: 'pointer',
                                            fontWeight: 600,
                                            fontSize: '11px',
                                            backgroundColor: isActive ? activeColor : 'transparent',
                                            color: isActive ? '#FFFFFF' : activeColor,
                                            borderColor: isActive ? activeColor : borderColor,
                                        }}
                                    />
                                    );
                                })}
                            </Box>
                        )}
                        {activeFile.pdfUrl ? (
                            <iframe
                                key={activeFile.pdfUrl}
                                src={activeFile.pdfUrl}
                                title={activeFile.fileName}
                                width="100%"
                                style={{ flex: 1, border: 'none', minHeight: '80vh' }}
                            />
                        ) : (
                            <Box sx={{ p: 4, textAlign: 'center' }}>
                                <Typography variant="body2" color="text.secondary">PDF preview not available</Typography>
                            </Box>
                        )}
                    </Box>
                </ViewerModalPopup>
            )}
        </>
    );
};

const EditTC: React.FC<NavTCNoProps> = ({ cell, type }) => {
    const { tcId, tcMetadataStatus, tcParentMetadataStatus, tcNo, tcVersionNo, tcPdfUploadStatus, tcUploadedFileName, tcNoPdfUrl, tcVersionNoPdfUrl, tcUploadedFiles, tcDateOfIssue } = cell.row.original;
    const navigate = useNavigate();
    const { setEditTCInfo, cbLicensingCode } = useTransactionCertificateStore();
    const { executePost } = useApi();
    const [previewOpen, setPreviewOpen] = useState(false);
    const [suppressRowClick, setSuppressRowClick] = useState(false);
    const [uploadModalOpen, setUploadModalOpen] = useState(false);
    const isCbUser = cbLicensingCode.startsWith("CB");
    const { fetchRecords, pagination, updateDTrackitV4Row } = useRecordsStore();

    const handleNavigation = (row: any) => {
        if (type === 'suppliers') {
            navigate(`/v4/tc/submited-tc/transaction-certificate/${tcId}`);
        } else {
            if (
                row?.tcMetadataStatus === "Submitted" ||
                row?.tcMetadataStatus === "Success" ||
                row?.tcMetadataStatus === "Rejected" ||
                row?.tcMetadataStatus === "Amending"
            ) {
                setEditTCInfo({ tcId: tcId, isParentStatus: true });
            } else {
                setEditTCInfo({ tcId: tcId, isParentStatus: false });
            }
            navigate(`/v4/tc/tc-details/base-details/${tcId}`);
        }
    };

    const handleEdit = async (row: any) => {
        try {
            const { tcVersionNumber, tcVersionNo: tcVersionNoFromRow, ...restData } = row;
            const tcVersionNo = tcVersionNoFromRow ?? tcVersionNumber ?? 0;

            const payload = {
                ...restData,
                tcVersionNo,
                tcCbLicensingCode: cbLicensingCode,
            };

            const url = `${TCAppConfig.EDIT_TC_DETAILS_V4}?tcId=${tcId}&tcCbLicensingCode=${encodeURIComponent(cbLicensingCode)}`;
            const result: any = await executePost(url, payload);

            if (result && result.status === 200) {
                if (
                    tcMetadataStatus === "Submitted" ||
                    tcMetadataStatus === "Success" ||
                    tcMetadataStatus === "Rejected"
                ) {
                    setEditTCInfo({
                        tcId: result.data.tcId,
                        isParentStatus: true,
                        tcMetadataStatus: tcMetadataStatus,
                    });
                } else {
                    setEditTCInfo({});
                }
                navigate(`/v4/tc/tc-details/base-details/${result.data.tcId}`);
            } else {
                console.warn('Edit TC did not return success:', result);
            }
        } catch (error: any) {
            console.error('Error editing TC:', error);
        }
    };

    const handleView = (event: React.MouseEvent) => {
        event.stopPropagation();
        setSuppressRowClick(false);
        setPreviewOpen(true);
    };

    const togglePreviewDrawer = (event?: React.MouseEvent) => {
        if (event && event.stopPropagation) {
            event.stopPropagation();
        }
        setSuppressRowClick(true);
        setPreviewOpen(false);
        setTimeout(() => setSuppressRowClick(false), 0);
    };

    const isIssueDateMissing = !tcDateOfIssue || tcDateOfIssue.toLowerCase() === 'none';

    const handleUploadPdf = (event: React.MouseEvent) => {
        event.stopPropagation();
        setUploadModalOpen(true);
    };

    const handleUploadSuccess = async (uploadResponse?: any) => {
        // TC upload API returns status + file info at the top level of the response body.
        if (uploadResponse?.tcPdfUploadStatus === 'Uploaded') {
            const updates: Partial<ICbLandingPageDTrackitTableDataV4> = {
                tcPdfUploadStatus: uploadResponse.tcPdfUploadStatus,
            };

            if (uploadResponse.tcNoPdfUrl)        updates.tcNoPdfUrl        = uploadResponse.tcNoPdfUrl;
            if (uploadResponse.tcVersionNoPdfUrl)  updates.tcVersionNoPdfUrl = uploadResponse.tcVersionNoPdfUrl;
            if (uploadResponse.tcDocumentUrl)      updates.tcDocumentUrl     = uploadResponse.tcDocumentUrl;

            const docName = uploadResponse.tcDocumentName || uploadResponse.tcUploadedFileName;
            if (docName) updates.tcUploadedFileName = docName;

            if (Array.isArray(uploadResponse.tcUploadedFiles) && uploadResponse.tcUploadedFiles.length > 0) {
                const existing = Array.isArray(tcUploadedFiles) ? tcUploadedFiles : [];
                updates.tcUploadedFiles = [...existing, ...uploadResponse.tcUploadedFiles];
            }

            updateDTrackitV4Row(tcId, updates);
            return;
        }

        // Fallback: full re-fetch when response doesn't carry the expected fields
        await fetchRecords({ tcCbLicensingCode: cbLicensingCode, source: 'dTrackitV4', pagination });
    };

    return (
        <>
            <Box
                display="flex"
                alignItems="center"
                onClick={() => {
                    if (!previewOpen && !suppressRowClick) {
                        handleNavigation(cell.row.original);
                    }
                }}
            >
                {["Success", "Amending"].includes(tcMetadataStatus) && (
                    <>
                        <Tooltip title={isIssueDateMissing ? "Issue date missing — open to view details" : "Upload PDF"}>
                            <IconButton onClick={handleUploadPdf} color="primary">
                                <UploadFileIcon sx={{ fontSize: 20, color: '#2C4748' }} />
                            </IconButton>
                        </Tooltip>
                        <Divider flexItem sx={{ marginX: 1 }} />
                    </>
                )}

                {(["Success", "Rejected"].includes(tcMetadataStatus)) && (
                    <>
                        <Tooltip title="Edit">
                            <IconButton
                                onClick={(event) => {
                                    event.stopPropagation();
                                    handleEdit(cell.row.original);
                                }}
                                color="primary"
                            >
                                <EditIcon sx={{ fontSize: 20, color: '#353C52' }} />
                            </IconButton>
                        </Tooltip>
                        <Divider flexItem sx={{ marginX: 1 }} />
                    </>
                )}

                {["Amending", "Draft"].includes(tcMetadataStatus) && isCbUser && (
                    <>
                        <Tooltip title="Continue Submission">
                            <IconButton
                                onClick={(event) => {
                                    event.stopPropagation();
                                    handleNavigation(cell.row.original);
                                }}
                                color="primary"
                            >
                                <RateReviewIcon sx={{ fontSize: 20, color: '#2C4748' }} />
                            </IconButton>
                        </Tooltip>
                        <Divider flexItem sx={{ marginX: 1 }} />
                    </>
                )}

                {tcMetadataStatus !== 'Draft' && (
                    <Tooltip title="View">
                        <IconButton onClick={handleView} color="primary">
                            <VisibilityIcon sx={{ fontSize: 20, color: '#F0CD7F' }} />
                        </IconButton>
                    </Tooltip>
                )}
            </Box>

            {["Success", "Amending"].includes(tcMetadataStatus) && (
                <TcPdfUploaderModal
                    open={uploadModalOpen}
                    onClose={() => setUploadModalOpen(false)}
                    tcId={tcId}
                    tcNo={tcNo || ''}
                    tcVersionNo={tcVersionNo || ''}
                    tcNoPdfUrl={tcNoPdfUrl}
                    tcVersionNoPdfUrl={tcVersionNoPdfUrl}
                    tcUploadedFiles={tcUploadedFiles}
                    submissionStatus={tcMetadataStatus}
                    cbLicensingCode={cbLicensingCode}
                    tcDateOfIssue={tcDateOfIssue}
                    onUploadSuccess={handleUploadSuccess}
                />
            )}

            {tcId && (
                <ViewerModalPopup
                    open={previewOpen}
                    onClose={togglePreviewDrawer}
                    title="Preview"
                >
                    <TcPdfMultiViewer
                        tcNoPdfUrl={tcNoPdfUrl}
                        tcVersionNoPdfUrl={tcVersionNoPdfUrl}
                        tcNo={tcNo}
                        tcVersionNo={tcVersionNo}
                        fallbackApiUrl={TCAppConfig.PREVIEW_TC_V4}
                        tcId={tcId}
                    />
                </ViewerModalPopup>
            )}
        </>
    );
};

// ─── Uploaded-PDF cell: click filename → full-screen PDF preview modal ───────
const UploadedFilePdfCell = ({ cell, row }: { cell: any; row: any }) => {
    const fileName = cell.getValue() as string;
    const { tcDocumentUrl } = row.original;
    const [previewOpen, setPreviewOpen] = useState(false);

    if (!fileName) return <span>—</span>;

    const handleOpen = (event: React.MouseEvent) => {
        event.stopPropagation();
        setPreviewOpen(true);
    };

    const handleClose = (event?: React.MouseEvent) => {
        if (event) event.stopPropagation();
        setPreviewOpen(false);
    };

    return (
        <>
            <Tooltip title={tcDocumentUrl ? `Click to view: ${fileName}` : fileName} arrow>
                <Typography
                    variant="body2"
                    onClick={tcDocumentUrl ? handleOpen : undefined}
                    sx={{
                        cursor: tcDocumentUrl ? 'pointer' : 'default',
                        color: tcDocumentUrl ? 'primary.main' : '#2C4748',
                        textDecoration: tcDocumentUrl ? 'underline' : 'none',
                        fontWeight: 500,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        maxWidth: 200,
                        '&:hover': tcDocumentUrl ? { color: 'primary.dark' } : {},
                    }}
                >
                    {fileName}
                </Typography>
            </Tooltip>

            {tcDocumentUrl && previewOpen && (
                <ViewerModalPopup
                    open={previewOpen}
                    onClose={handleClose}
                    title={`Uploaded Document — ${fileName}`}
                >
                    <iframe
                        src={tcDocumentUrl}
                        title={fileName}
                        width="100%"
                        height="100%"
                        style={{ border: 'none', minHeight: '80vh' }}
                    />
                </ViewerModalPopup>
            )}
        </>
    );
};
// ─────────────────────────────────────────────────────────────────────────────

export const tableColumns = {
    dTrackit: [
        {
            accessorKey: "Action",
            header: "",
            minSize: 40,
            maxSize: 60,
            Cell: EditTC,

        },
        {
            accessorKey: "tcNo",
            header: "TC No.",
            minSize: 70,
            maxSize: 100
        },
        {
            accessorKey: "tcVersionNumber",
            header: "TC Version No.",
            minSize: 120,
            maxSize: 150,
        },
        {
            accessorKey: "sellerName",
            header: "Seller",
            minSize: 80,
            maxSize: 100,
        },
        {
            accessorKey: "buyerName",
            header: "Buyer",
            minSize: 60,
            maxSize: 100,
        },
        {
            accessorKey: "buyerCountry",
            header: "Buyer Country/Area",
            minSize: 100,
            maxSize: 180,
        },
        {
            accessorKey: "tcStandard",
            header: "TC Standard",
            minSize: 100,
            maxSize: 180,
        Cell: ({ cell }: { cell: any }) => {
            const standards = cell.getValue();
            if (Array.isArray(standards)) {
                return <span>{standards.join(", ")}</span>;
            }
            return <span>{standards}</span>;
        }
        },
        {
            accessorKey: "tcNetShippingWeight",
            header: "TC Certified Weight (kg)",
            minSize: 200,
            maxSize: 250,
            Cell: certifiedWeightCell
        },
        {
            accessorKey: "tcDateOfIssue",
            header: "Issue Date",
            minSize: 80,
            maxSize: 120,
        },
        {
            accessorKey: "tcMetadataStatus",
            header: "Submission Status",
            minSize: 120,
            maxSize: 170,
            Cell: StatusCell
        },
        {
            accessorKey: "tcCreationDate",
            header: "Submitted Date",
            minSize: 100,
            maxSize: 150,
            Cell: ({ cell }: { cell: any }) => {
                const date = cell.getValue(); // Access the raw date value
                const formattedDate = moment(date).isValid()
                    ? moment(date).format("YYYY-MM-DD") // Format valid date
                    : date; // Fallback to raw value if invalid
                return <span>{formattedDate}</span>;
            },
        },
        {
            accessorKey: "tcMetadataRejectionReason",
            header: "Reject Reason",
            minSize: 80,
            maxSize: 140,
            Cell: ({ row }: any) => <RejectReasonCell row={row} />,
        },
        {
            accessorKey: "tcParentMetadataStatus",
            header: "Parent Reject Reason",
            minSize: 80,
            maxSize: 140,
            enableHiding: true,
            show: false,
        },
        {
          accessorKey: "tcId",
          header: "TC-ID",
          minSize: 80,
          maxSize: 140,
          enableHiding: true,
          show: false,
        }
    ] as MRT_ColumnDef<{ status: string }>[],

    dTrackitV4: [
        {
            accessorKey: "Action",
            header: "",
            minSize: 40,
            maxSize: 60,
            Cell: EditTC,
        },
        {
            accessorKey: "tcNo",
            header: "TC Number",
            minSize: 150,
            maxSize: 200,
        },
        {
            accessorKey: "tcVersionNo", // v4 API returns tcVersionNo
            header: "TC Version Number",
            minSize: 150,
            maxSize: 200,
        },
        {
            accessorKey: "sellerName",
            header: "Seller",
            minSize: 80,
            maxSize: 100,
        },
        {
            accessorKey: "buyerName",
            header: "Buyer",
            minSize: 60,
            maxSize: 100,
        },
        {
            accessorKey: "buyerCountry",
            header: "Buyer Country/Area",
            minSize: 100,
            maxSize: 180,
        },
        {
            accessorKey: "tcStandard",
            header: "TC Standard",
            minSize: 100,
            maxSize: 180,
            Cell: ({ cell }: { cell: any }) => {
                const standards = cell.getValue();
                if (Array.isArray(standards)) {
                    return <span>{standards.join(", ")}</span>;
                }
                return <span>{standards}</span>;
            },
        },
        {
            accessorKey: "tcNetShippingWeight",
            header: "TC Certified Weight (kg)",
            minSize: 200,
            maxSize: 250,
            Cell: certifiedWeightCell,
        },
        {
            accessorKey: "tcDateOfIssue",
            header: "Issue Date",
            minSize: 80,
            maxSize: 120,
        },
        {
            accessorKey: "tcMetadataStatus",
            header: "Submission Status",
            minSize: 120,
            maxSize: 170,
            Cell: StatusCell,
        },
        {
            accessorKey: "tcCreationDate",
            header: "Submitted Date",
            minSize: 100,
            maxSize: 150,
            Cell: ({ cell }: { cell: any }) => {
                const date = cell.getValue();
                // Handle 'None' or empty string values
                if (!date || date === '') {
                    return '-';
                }
                const formattedDate = moment(date).isValid()
                    ? moment(date).format("YYYY-MM-DD")
                    : '-';
                return <span>{formattedDate}</span>;
            },
        },
        {
            accessorKey: "tcMetadataRejectionReason",
            header: "Reject Reason",
            minSize: 80,
            maxSize: 140,
            Cell: ({ row }: any) => <RejectReasonCell row={row} />,
        },
        {
            accessorKey: "tcId",
            header: "TC-ID",
            minSize: 80,
            maxSize: 140,
            enableHiding: true,
            show: false,
        },
        {
            accessorKey: "tcUploadedFiles",
            header: "Uploaded File(s)",
            minSize: 160,
            maxSize: 260,
            enableHiding: true,
            enableColumnFilter: false,
            Cell: ({ cell, row }: { cell: any; row: any }) => {
                const rawFiles: Array<{ fileName: string; uploadedAt?: string }> = cell.getValue() || [];
                if (!rawFiles || rawFiles.length === 0) return null;

                const normalize = (str: string) => (str || "").toLowerCase().replace(/[-_\s]/g, "");
                // SC-style filter: show only the base certificate (-00) and the current active version.
                // Intermediate amendments are kept in the DB but hidden — same as SC behaviour.
                const normTcNo        = normalize(row.original.tcNo || '');        // always the -00 base
                const normTcVersionNo = normalize(row.original.tcVersionNo || ''); // current active version

                // Sort most-recent first, then filter to base + current only
                const sorted = [...rawFiles].sort((a, b) => {
                    const ta = a.uploadedAt ? new Date(a.uploadedAt).getTime() : 0;
                    const tb = b.uploadedAt ? new Date(b.uploadedAt).getTime() : 0;
                    return tb - ta;
                });

                const filtered = sorted.filter((entry: any) => {
                    const normName = normalize(entry.fileName || entry || "");
                    const matchesBase    = normTcNo && normName.includes(normTcNo);
                    const matchesCurrent = normTcVersionNo && normTcVersionNo !== normTcNo
                                          && normName.includes(normTcVersionNo);
                    return matchesBase || matchesCurrent;
                });

                if (filtered.length === 0) return null;

                // Build typed file objects: most-recent first, determine base vs amended by filename
                const fileObjects = filtered.map((entry: any) => {
                    const fn = entry.fileName || '';
                    const isBase = /-00[_.]/.test(fn.toLowerCase());
                    const pdfUrl = isBase
                        ? (row.original.tcNoPdfUrl || row.original.tcDocumentUrl || '')
                        : (row.original.tcVersionNoPdfUrl || row.original.tcDocumentUrl || '');
                    return { fileName: fn, pdfUrl, isBase, label: isBase ? 'Original Certificate' : 'Amended Certificate' };
                });

                return <UploadedFilesChip files={fileObjects} />;
            },
        },
        {
            accessorKey: "tcPdfUploadStatus",
            header: "Upload Status",
            minSize: 110,
            maxSize: 160,
            enableHiding: true,
            Cell: ({ cell, row }: { cell: any; row: any }) => {
                const status = cell.getValue() as string;
                const metadataStatus = row.original.tcMetadataStatus;

                if (!status) {
                    return ["Success", "Amending"].includes(metadataStatus) ? (
                        <Chip label="Not Uploaded" color="default" size="small" variant="outlined" />
                    ) : null;
                }

                const color: "success" | "default" = status === "Uploaded" ? "success" : "default";
                return <Chip label={status} color={color} size="small" variant="outlined" />;
            },
        },
    ] as MRT_ColumnDef<{ status: string }>[],

    historical: [
        {
            accessorKey: "tcId",
            header: "TC No.",
            minSize: 60,
            maxSize: 150
        },
        {
            accessorKey: "tcVersionNumber",
            header: "TC Version No.",
            minSize: 60,
            maxSize: 100,
        },
        {
            accessorKey: "sellerName",
            header: "Seller",
            minSize: 80,
            maxSize: 150,
        },
        {
            accessorKey: "buyerName",
            header: "Buyer",
            minSize: 80,
            maxSize: 150,
        },
        {
            accessorKey: "buyerCountry",
            header: "Buyer Country/Area",
            minSize: 80,
            maxSize: 140,
        },
        {
            accessorKey: "tcNetShippingWeight",
            header: "TC Certified Weight (kg)",
            minSize: 100,
            maxSize: 150,
        },
        {
            accessorKey: "tcDateOfIssue",
            header: "Issue Date",
            minSize: 80,
            maxSize: 120,

        }
    ] as MRT_ColumnDef<{ status: string }>[],

    eTrackit: [
        {
            accessorKey: "etcNo",
            header: "eTC No.",
            minSize: 60,
            maxSize: 100,
            Cell: NavETCNo
        },
        {
            accessorKey: "etcVersionNumber",
            header: "eTC Version No.",
            minSize: 100,
            maxSize: 160,
        },
        {
            accessorKey: "etcStatus",
            header: "eTC Status",
            minSize: 80,
            maxSize: 120,
        },
        {
            accessorKey: "sellerName",
            header: "Seller",
            minSize: 80,
            maxSize: 150,
        },
        {
            accessorKey: "buyerName",
            header: "Buyer",
            minSize: 80,
            maxSize: 150,
        },
        {
            accessorKey: "buyerCountry",
            header: "Buyer's Country/Area",
            minSize: 200,
            maxSize: 250,
        },
        {
            accessorKey: "tcNetShippingWeight",
            header: "eTC Certified Weight (kg)",
            minSize: 300,
            maxSize: 350,
        },
        {
            accessorKey: "tcCreationDate",
            header: "Creation Date",
            minSize: 80,
            maxSize: 150,
        },
        {
            accessorKey: "tcDateOfIssue",
            header: "Issued Date",
            minSize: 80,
            maxSize: 120,
        },
        {
            accessorKey: "pendingDays",
            header: "Pending Days",
            minSize: 100,
            maxSize: 140,
        },
        {
            accessorKey: "tcMetadataStatus",
            header: "Current Status",
            minSize: 80,
            maxSize: 150,
            Cell: StatusCell
        },
        {
            accessorKey: "tcMetadataRejectionReason",
            header: "Reject Reason",
            minSize: 80,
            maxSize: 150,
        }
    ] as MRT_ColumnDef<{ status: string }>[],
    suppliers: [
        {
            accessorKey: 'tcNo', // From payload
            header: 'TC/e TC ID', // Column header text
            minSize: 150,
            maxSize: 250,
            Cell: NavSupNo
        },
        {
            accessorKey: 'buyerName', // Combined Buyer/Seller
            header: 'Buyer',
            minSize: 150,
            maxSize: 250,
        },
        {
            accessorKey: 'sellerName', // Combined Buyer/Seller
            header: 'Seller',
            minSize: 150,
            maxSize: 250,
        },
        {
            accessorKey: 'tcCreationDate', // From payload
            header: 'Creation Date',
            minSize: 150,
            maxSize: 250,
            Cell: ({ cell }: { cell: any }) => {
                const date = cell.getValue(); // Access the raw date value
                const formattedDate = moment(date).isValid()
                    ? moment(date).format("YYYY-MM-DD") // Format valid date
                    : date; // Fallback to raw value if invalid
                return <span>{formattedDate}</span>;
            },
        },
        {
            accessorKey: 'tcDateOfIssue', // From payload
            header: 'Issue Date',
            minSize: 150,
            maxSize: 250,
        },
        {
            accessorKey: 'volumeSold', // Placeholder as it's not in the payload
            header: 'Volume Sold',
            minSize: 150,
            maxSize: 200,
        },
        {
            accessorKey: 'volumeBought', // Placeholder as it's not in the payload
            header: 'Volume Bought',
            minSize: 150,
            maxSize: 200,
        },
        {
            accessorKey: 'tcStatus', // From payload
            header: 'Status',
            minSize: 150,
            maxSize: 200,
            Cell: ({ cell }: any) => {
                const statusMapping: Record<string, string> = {
                    V: "Valid",
                    E: "Expired",
                    S: "Suspended",
                    W: "Withdrawn",
                };

                // Extract the status value from the row data
                const statusValue = cell.getValue();

                // Map the status value to the corresponding label
                const label = statusMapping[statusValue] || statusValue;

                return <span>{label}</span>;
            }
        },
    ] as MRT_ColumnDef<{ status: string }>[],
    materialLedger: [
        {
            accessorKey: 'transactionType',
            header: 'Transaction Type',
            minSize: 150,
            maxSize: 250,
        },
        {
            accessorKey: 'inventoryType',
            header: 'Inventory Type',
            minSize: 150,
            maxSize: 250,
        },
        {
            accessorKey: 'tCeTCMDFNumber',
            header: 'Transaction/MDF No.',
            minSize: 150,
            maxSize: 250,
        },
        {
            accessorKey: 'sellerBuyerName',
            header: 'Seller/Buyer Name',
            minSize: 150,
            maxSize: 250,
        },
        {
            accessorKey: 'transactionDate',
            header: 'Transaction Date',
            minSize: 150,
            maxSize: 250,
        },
        {
            accessorKey: 'productNumber',
            header: 'Product No.',
            minSize: 150,
            maxSize: 250,
        },
        {
            accessorKey: 'productCategory',
            header: 'Product Category',
            minSize: 150,
            maxSize: 250,
        },
        {
            accessorKey: 'productDetail',
            header: 'Product Detail',
            minSize: 150,
            maxSize: 250,
        },
        {
            accessorKey: 'rmComposition',
            header: 'RM Composition',
            minSize: 150,
            maxSize: 250,
        },
        {
            accessorKey: 'certifiedRmCode',
            header: 'Certified RM CD',
            minSize: 150,
            maxSize: 250,
        },
        {
            accessorKey: 'certifiedWeightBought',
            header: 'Certified Weight Purchased (kg)',
            minSize: 150,
            maxSize: 250,
        },
        {
            accessorKey: 'certifiedWeightSold',
            header: 'Certified Weight Sold (kg)',
            minSize: 150,
            maxSize: 250,
        },
        {
            accessorKey: 'inputTcCertificateUsed',
            header: 'Certified Volume Used',
            minSize: 150,
            maxSize: 250,
        },
        {
            accessorKey: 'balance',
            header: 'Balance',
            minSize: 150,
            maxSize: 250,
        },
    ] as MRT_ColumnDef<{ status: string }>[],
};

export const getColumnsBySource = (source: string) => {
    switch (source) {
        case "dTrackit":
            return tableColumns.dTrackit;
        case "dTrackitV4":
            return tableColumns.dTrackitV4;
        case "historical":
            return tableColumns.historical;
        case "eTrackit":
            return tableColumns.eTrackit;
        case "suppliers":
            return tableColumns.suppliers;
        case "materialLedger":
            return tableColumns.materialLedger;
        default:
            return tableColumns.dTrackit; // fallback
    }
};